import { useState } from 'react';
import { Popover, Tag, Typography } from 'antd';
import { PreviewableModal } from 'common/components';
import { BookOutlined } from '@ant-design/icons';
import { wizardIcons } from 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/constants/wizardIcons';

import 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/styles/WizardQuestionHelp.less';

const ExampleImage = ({ src, label }) => {
  const [previewVisible, setPreviewVisible] = useState(false);
  const [hoverVisible, setHoverVisible] = useState(false);

  return (
    <>
      <Popover
        trigger={['hover', 'focus']}
        visible={hoverVisible && !previewVisible}
        onVisibleChange={setHoverVisible}
        placement='left'
        zIndex={1100}
        content={
          <img
            className='wizard-question-help__preview'
            src={src}
            alt={label}
            decoding='async'
          />
        }
      >
        <button
          type='button'
          className='wizard-question-help__thumbnail'
          aria-label={`Preview full image: ${label}`}
          onClick={() => {
            setHoverVisible(false);
            setPreviewVisible(true);
          }}
        >
          <img src={src} alt={label} decoding='async' />
        </button>
      </Popover>
      {previewVisible && (
        <PreviewableModal
          visible
          title={label}
          type='images'
          link={src}
          isDocument={false}
          isDownload={false}
          cancelModal={() => setPreviewVisible(false)}
        />
      )}
    </>
  );
};

const WizardQuestionHelp = ({ help, stepKey }) => {
  if (!help) return null;

  const images = help.images || (help.image ? [help.image] : []);
  const hasImages = images.length > 0 || help.groupedImages?.length > 0;
  const Icon = wizardIcons[stepKey] || BookOutlined;

  return (
    <section className='wizard-question-help' aria-label={help.title}>
      <div className='wizard-question-help__title'>
        <span className='wizard-question-help__heading-icon'><Icon /></span>
        <span>{help.title}</span>
      </div>
      <div className='wizard-question-help__body'>
        {help.definitions ? (
          <dl className='wizard-question-help__definitions'>
            {help.definitions.map(({ label, description }) => (
              <div key={label}>
                <dt>{label}</dt>
                <dd>{description}</dd>
              </div>
            ))}
          </dl>
        ) : (
          <div className='wizard-question-help__description'>{help.description}</div>
        )}
        {hasImages && (
          <>
            <div className='wizard-question-help__examples-title'>Example Images</div>
            <div className='wizard-question-help__instructions'>
              Hover over image to enlarge. Click to view the full image.
            </div>
            {images.length > 0 && (
              <div className='wizard-question-help__images'>
                {images.map((src, index) => (
                  <ExampleImage
                    key={`${src}-${index}`}
                    src={src}
                    label={`${help.title} example ${index + 1}`}
                  />
                ))}
              </div>
            )}
            {help.groupedImages?.length > 0 && (
              <div className='wizard-question-help__groups'>
              {help.groupedImages.map((group) => (
              <div className='wizard-question-help__group' key={group.label}>
                <Typography.Text strong>{group.label}</Typography.Text>
                <div className='wizard-question-help__columns'>
                  <div>
                    <Tag color='blue' className='wizard-question-help__label'>
                      Innerpack
                    </Tag>
                    <div className='wizard-question-help__images'>
                      {group.innerpack.map((src, index) => (
                        <ExampleImage
                          key={`${src}-${index}`}
                          src={src}
                          label={`${group.label} innerpack example ${index + 1}`}
                        />
                      ))}
                    </div>
                  </div>
                  <div>
                    <Tag color='green' className='wizard-question-help__label'>
                      Unit
                    </Tag>
                    <div className='wizard-question-help__images'>
                      <ExampleImage src={group.unit} label={`${group.label} unit`} />
                    </div>
                  </div>
                </div>
              </div>
              ))}
              </div>
            )}
          </>
        )}
      </div>
    </section>
  );
};

export default WizardQuestionHelp;
